import { DragEvent } from "react";

interface UseDropProps {
  actionKey: string;
  onDrop: (data: any) => void;
  disabled?: boolean;
}

export const useDrop = ({
  actionKey,
  onDrop,
  disabled = false,
}: UseDropProps) => {
  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const data = e.dataTransfer.getData(actionKey);
    onDrop(JSON.parse(data));
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return {
    dropProps: {
      ...(disabled
        ? {}
        : {
            onDrop: handleDrop,
            onDragOver: handleDragOver,
          }),
    },
  };
};

interface UseDragProps {
  actionKey: string;
  dataTransfer: unknown;
  disabled?: boolean;
}

export const useDrag = ({
  actionKey,
  dataTransfer,
  disabled = false,
}: UseDragProps) => {
  const handleDragStart = (e: DragEvent<HTMLDivElement>) => {
    if (disabled) return;

    e.dataTransfer.setData(actionKey, JSON.stringify(dataTransfer));
  };

  return {
    dragProps: {
      draggable: !disabled,
      ...(disabled ? {} : { onDragStart: handleDragStart }),
    },
  };
};
